import { render, staticRenderFns } from "./FormAnswer.vue?vue&type=template&id=31ea7a1f&scoped=true"
import script from "./FormAnswer.vue?vue&type=script&lang=js"
export * from "./FormAnswer.vue?vue&type=script&lang=js"
import style0 from "./FormAnswer.vue?vue&type=style&index=0&id=31ea7a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea7a1f",
  null
  
)

export default component.exports